<template>
	<header
		class="app-header is-web-app"
		:class="{ 'is-inner-page': isInnerPage, 'is-scrolled': isScrolled }"
		ref="headerRef"
	>
		<div class="main-container header-container" v-focus-section>
			<router-link to="/home" v-focus class="app-logo">
				<img fetchpriority="high" :src="logoSrc" alt="" />
			</router-link>
			<ul class="main-menu" v-focus-section v-show="!isSearching">
				<li>
					<router-link to="/home" v-focus class="vl-font-size--25">{{ $t("header.frontpage") }}</router-link>
				</li>
				<li>
					<router-link to="/movies" v-focus class="vl-font-size--25">{{ $t("header.movies") }}</router-link>
				</li>
				<li>
					<router-link to="/series" v-focus class="vl-font-size--25">{{ $t("header.series") }}</router-link>
				</li>
				<!-- <li>
					<router-link to="/" v-focus class="vl-font-size--25">Κατηγορίες</router-link>
				</li> -->
			</ul>

			<header-section-right @search-closed="isSearching = false" @search-opened="isSearching = true" />
			<!-- <div class="section--right">
				<Login
					v-focus-section
					v-if="
						(isLoggedIn === false && width > 960 && !isSearching) ||
						(isLoggedIn === false && width <= 960 && !isSearching && !isMobileDevice)
					"
				/>
				<LangSwitcher v-focus v-if="width > 960 && !isSearching" />
				<Search @search-opened="isSearching = true" @search-closed="isSearching = false" v-focus />
				<profile v-focus-section v-if="isLoggedIn === true && width > 960" />

				<img
					v-if="!isLoggedIn && width > 960"
					@click="triggerLogin"
					class="login-avatar"
					src="../images/login_avatar.webp"
					alt="Login"
					v-tooltip.bottom="'Σύνδεση'"
				/>

				<div class="mobile-menu" v-if="width <= 960 && !isMobileDevice">
					<button @click="toggleMenuVisibility" aria-haspopup="true" aria-controls="overlay_menu">
						<IconMenu :open="isBurgerMenuOpen"></IconMenu>
					</button>
					<TieredMenu ref="menu" id="overlay_menu" :model="items" :popup="true" appendTo="self">
						<template #item="{ hasSubmenu, item, props }">
							<button v-if="item.id === 'register_menu_item'" class="btn red tiered-menu--button" @click="item.command">
								{{ item.label }}
							</button>
							<a v-else class="flex items-center" v-bind="props.action">
								<span>{{ item.label }}</span>
								<i v-if="hasSubmenu" class="pi pi-angle-right ml-auto"></i>
							</a>
						</template>
					</TieredMenu>
				</div>
			</div> -->
		</div>
	</header>
</template>

<script lang="ts" setup>
	import { computed, ComputedRef, ref, onMounted, onUnmounted, Ref } from "vue"
	import { useUserStore } from "../stores/user"
	import { isNativeDevice, url } from "../helper"
	// @ts-ignore This import works correctly
	import logoImage from "../images/valor_logo.svg" // Vite will resolve this path
	import { useLogin } from "../composables/useLogin"
	import { useRoute } from "vue-router"
	import HeaderSectionRight from "./header/HeaderSectionRight.vue"

	const isSearching = ref(false)
	const route = useRoute()
	const { login } = useLogin()

	// Dynamically determine the logo source - adjusted for Tizen environment
	const logoSrc =
		(import.meta.env as any).MODE === "tizen"
			? "dist/assets/valor_logo.svg" // Production path
			: logoImage

	const userStore: ReturnType<typeof useUserStore> = useUserStore()
	const isScrolled: Ref<boolean> = ref(false)
	const scrollThreshold: number = 50 // pixels scrolled before adding class

	const isInnerPage: ComputedRef<boolean> = computed((): boolean => {
		return route.name === "InnerMovie" || route.name === "InnerSeries"
	})

	/**
	 * Handle scroll event to toggle isScrolled state.
	 * @registered on mounted lifecycle hook
	 * @unregistered on unmounted lifecycle hook
	 */
	const handleScroll = (): void => {
		if (window.scrollY > scrollThreshold) {
			isScrolled.value = true
		} else {
			isScrolled.value = false
		}
	}

	onMounted(() => {
		window.addEventListener("scroll", handleScroll)
	})

	onUnmounted(() => {
		window.removeEventListener("scroll", handleScroll)
	})
</script>

<style lang="scss" scoped>
	.app-header {
		z-index: 10;
		padding: 4px 20px;
		transition: all 0.3s ease;
		width: 100%;
		// background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 30%, transparent);
		background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.6) 35%, rgba(0, 0, 0, 0) 100%);
		// background: var(--dark-gray);

		&.is-scrolled {
			background: var(--black);
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}

		.main-menu {
			display: flex;
		}

		// &.is-inner-page {
		// 	background: black;
		// }

		&.is-web-app {
			position: sticky;
			width: 100%;
			top: 0;
			z-index: 9999;
			padding: 0;
		}

		@include br.respond-to(br.$laptop-large) {
			.main-menu {
				gap: 20px;
				a {
					font-size: 22px !important;
				}
			}
		}

		@include br.respond-to(br.$laptop-large) {
			// padding: 10px 20px;
			transition: all 0.3s ease;
			// background: var(--dark-gray);

			.app-logo img {
				width: 250px;
				height: auto;
			}

			.main-menu {
				gap: 60px;
				a {
					font-size: 20x !important;
					transition: font-size 0.3s ease;
				}
			}
			// .profile img {
			// 	height: 40px;
			// 	width: 40px !important;
			// }
		}

		@include br.respond-to(br.$desktop-medium) {
			.main-menu {
				gap: 40px;
			}
		}

		@include br.respond-to(br.$tablet-huge) {
			.main-menu {
				display: none;
			}
		}

		@include br.tablet-down {
			// display: none;
			padding: 10px 15px;

			.app-logo img {
				width: 180px;
				height: auto;
			}

			// .main-menu {
			// 	// display: none;
			// }
		}
	}

	.main-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.app-logo img {
		transition: height 0.3s ease;
		width: 280px;
	}

	.header-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		// padding: 10px 25px;
		padding: 10px 0;
	}
</style>
